import _ from 'lodash';
import moment from 'moment';
import app from '$$app';
import Store from '$$globalStore';
import filterConstants from './constants';
import constants from '$$helpers/constants';
import projectsModel from '$$projectModel';
import routerHelper from '$$routerHelper';
import multiViewsProjectsModel from '$$multiviewModel';
import customColumnsComponent from '../../components/userCustomColumns';
import rights from '../../components/rights/index';
import pricingHelpers from '../../helpers/pricingHelper';
import reportConstants from '../reports/include/constants';

const PORTFOLIO_PROJECT_VIEW_RIGHTS = [
  'gantt_chart',
  'board_view',
  'list_view',
  'workload',
  'resources_page',
  'overview',
  'calendar',
];

const resourcesLocale = {
  realResource: __('resources_layout_header_title_1'),
  virtualResource: __('resources_layout_header_title_2'),
};

const unassigned = {
  id: '-1',
  value: __('notAssigned'),
  img: '',
};

const helpers = {
  prepareStaticItems(filterType, staticFilterItems, advancedSettings) {
    let staticItemsClone = _.cloneDeep(staticFilterItems);

    const filtersWithSwitchItem = [
      filterConstants.FILTERS.reportsProgressMilestone,
      filterConstants.FILTERS.reportsProgressStatuses,
      filterConstants.FILTERS.reportsProgressSchedule,
      filterConstants.FILTERS.reportsProgressPortfolio,
      filterConstants.FILTERS.reportsBudgetProject,
      filterConstants.FILTERS.reportsTimeProject,
      filterConstants.FILTERS.timeloglist,
      filterConstants.FILTERS.reportsBudgetResource,
      filterConstants.FILTERS.reportsTimeResource,
    ];
    const filtersWithTimeDateRange = [filterConstants.FILTERS.history];

    staticItemsClone = staticItemsClone.map(item => ({
      ...this.hideFilterItemIfNedded(item, advancedSettings),
    }));

    if (filterType && filtersWithSwitchItem.includes(filterType)) {
      staticItemsClone = this.prepareItemsWithSwitchTemplate(staticItemsClone, [filterConstants.PROPERTY.gantt_id, filterConstants.PROPERTY.portfolio_id]);
    }

    if (filterType && filtersWithTimeDateRange.includes(filterType)) {
      staticItemsClone = this.prepareDateWithTime(staticItemsClone);
    }

    return staticItemsClone.filter(item => !item.hide);
  },
  prepareFlatFilterItems(staticFilterItems, advancedSettings) {
    let flatItems = _.cloneDeep(staticFilterItems);

    flatItems = flatItems.map(item => ({
      ...this.hideFilterItemIfNedded(item, advancedSettings),
    }));

    return flatItems.filter(item => !item.hide);
  },
  hideFilterItemIfNedded(item, advancedSettings) {
    if (filterConstants.PROPERTY.portfolio_id === item.property) {
      if (!rights.account.hasRight('multiview_all_features') || advancedSettings?.baselineEnabled) {
        return {
          ...item,
          hide: true,
        };
      }
    }

    if (filterConstants.PROPERTY.overdue === item.property) {
      if (!pricingHelpers.checkPricingAccess('overdue_tasks')) {
        return {
          ...item,
          hide: true,
        };
      }
    }

    if (filterConstants.PROPERTY.text === item.property && advancedSettings?.mode === 'graphic') {
      return {
        ...item,
        hide: true,
      };
    }

    if (filterConstants.PROPERTY.assignee === item.property && advancedSettings?.mode === 'graphic') {
      return {
        ...item,
        hide: true,
      };
    }

    return item;
  },
  prepareItemsWithSwitchTemplate(staticItems, switchProps) {
    let switchLabel = 'filter_option';
    const switchItems = staticItems.filter(item => switchProps.includes(item.property) && !item.hide);

    if (switchItems.length > 1) {
      switchItems.forEach(item => {
        switchLabel += `_${item.property}`;
      });

      const filterSwitchItem = [{
        isTab: true,
        label: __(`${switchLabel}`),
        filterItems: switchItems,
      }];

      const otherItems = staticItems.filter(item => !switchProps.includes(item.property));

      return filterSwitchItem.concat(otherItems);
    }

    return staticItems;
  },
  prepareDateWithTime(staticItems) {
    const props = [filterConstants.PROPERTY.date, filterConstants.PROPERTY.time];
    const dateItems = staticItems.filter(item => props.includes(item.property));
    const items = staticItems.filter(item => !props.includes(item.property));

    const rangeDateWithTime = {
      isDateWithTime: true,
      filterItems: dateItems,
    };

    items.push(rangeDateWithTime);

    return items;
  },
  preapreResourcesOptions(resources, filterProperty, filterType) {
    const real = resources.filter(res => res.userId).sort((a, b) => a.name.localeCompare(b.name));
    let virtual = [];

    const reportFilterWithoutVirtualResources = [
      filterConstants.FILTERS.timeloglist, 
      filterConstants.FILTERS.history
    ];

    const filterAssigneeWithoutUnassignee = [
      filterConstants.FILTERS.reportsBudgetResource,
    ]

    const assignVirtualResources = !reportFilterWithoutVirtualResources.includes(filterType);

    if (assignVirtualResources) {
      virtual = resources.filter(res => !res.userId).sort((a, b) => a.name.localeCompare(b.name));
    }

    if (filterProperty === filterConstants.PROPERTY.reporter) {
      return real.map(item => ({ ...item, img: item.photo || item.picture, value: item.name }));
    }

    const preparedResources = [...real, ...virtual].map(item => {
      const resource = { ...item };

      resource.img = item.photo || item.picture;
      resource.value = item.name;
      
      if (assignVirtualResources) {
        resource.group = item.userId ? resourcesLocale.realResource : resourcesLocale.virtualResource;
      }

      return resource;
    });

    const hasUnassignedOption = filterProperty === filterConstants.PROPERTY.assignee && !filterAssigneeWithoutUnassignee.includes(filterType);

    if (hasUnassignedOption) {
      preparedResources.unshift(unassigned);
    }

    return preparedResources;
  },
  getOptionsByPropAndProjectIds(projectIds, property, filterType) {
    const resources = [
      filterConstants.PROPERTY.reporter,
      filterConstants.PROPERTY.resource_id,
      filterConstants.PROPERTY.assignee,
    ];

    if (resources.includes(property)) {
      return this.getResourcesOptions(projectIds, property, filterType);
    }

    if (property === filterConstants.PROPERTY.gantt_id) {
      return this.getProjectsOptions(projectIds);
    }

    if (property === filterConstants.PROPERTY.portfolio_id) {
      return this.getPortfoliosOptions();
    }

    if (property === filterConstants.PROPERTY.status) {
      return this.getStatusOptions(projectIds);
    }

    if (property === filterConstants.PROPERTY.priority) {
      return this.getPriorityOptions(projectIds);
    }

    if (property === filterConstants.PROPERTY.type) {
      return filterConstants.TYPE_OPTIONS;
    }
    if (property === filterConstants.PROPERTY.event) {
      return filterConstants.EVENT_OPTIONS;
    }

    if (property === filterConstants.PROPERTY.owner_id) {
      return this.getProjectOwnersOptions(projectIds);
    }

    if (property === filterConstants.PROPERTY.project_status) {
      return this.getProjectStatusesOptions(projectIds);
    }

    return null;
  },
  getProjectOwnersOptions(projectIds) {
    const owners = projectIds.map(id => ({
      ...rights.project.getOwnerByGanttId(id),
    })).filter((owner, index, self) => index === self.findIndex(o => o.id === owner.id));

    return this.preapreResourcesOptions(owners);
  },
  getProjectStatusesOptions(projectIds) {
    const statuses = projectIds.map(id => ({
      ...Store.getters['teamSetting/statusDataForProject'](id),
    }));
    const projectStatusesLocales = ['no_status_locale', 'on_track_locale', 'at_risk_locale', 'off_track_locale'];

    return statuses.map(({
      selectOption: {
        id, value, background, labelColor,
      },
    }) => ({
      id,
      value: projectStatusesLocales.includes(value) ? __(value) : value,
      color: background,
      labelColor,
    })).filter((status, index, self) => index === self.findIndex(o => o.id === status.id));
  },
  getProjectsOptions(projectIds) {
    const projectsOptions = projectIds.filter(id => {
      const projectData = projectsModel.getProjectDataById(id);

      // if (projectData && !projectData?.is_archived) {
      //   return id;
      // }
      if (projectData) {
        return id;
      }
    }).map(id => {
      const projectData = projectsModel.getProjectDataById(id);

      return {
        id: projectData.id,
        value: projectData.name,
        is_jira: projectData.is_jira,
      };
    });

    return projectsOptions;
  },
  getPortfoliosOptions() {
    const portfolios = multiViewsProjectsModel.getAllMultiviews();

    return portfolios.map(p => ({
      id: p.id,
      value: p.name,
      projectIds: p.ganttIDs,
    }));
  },
  getResourcesOptions(projectIds, property, filterType) {
    const resources = Store.getters['resourcesModel/getResourcesByProjectIdsForUI'](projectIds);

    // projectIds.forEach(projectId => {
    //   const resourcesByProjectId = Store.getters['resourcesModel/getResourcesByProjectIdForUI'](projectId);

    //   resources = _.unionBy(resources, resourcesByProjectId, 'id');
    // });

    const preparedResources = this.preapreResourcesOptions(resources, property, filterType);

    // if (filterConstants.PROPERTY.assignee === property) {
    //   preparedResources = preparedResources.filter(res => {
    //     const resourceTasks = Store.getters['tasksModel/getTasksByResourceIdAndGanttIds'](res.id, projectIds);

    //     if (resourceTasks.length || res.id === '-1' || res.userId === user.id) {
    //       return res;
    //     }
    //   });
    // }

    return preparedResources;
  },
  getStatusOptions(projectIds) {
    const allStatuses = [];
    const projects = this.getProjectsOptions(projectIds);

    projects.filter(item => item.is_jira).forEach(project => {
      const jiraStatuses = Store.getters['columns/getJiraColumnByNameAndProjectId']('status', project.id);

      if (jiraStatuses && jiraStatuses.options.length) {
        jiraStatuses.options.forEach(status => {
          const {
            id, jira_field_id, name, value, is_default, icon, default_progress, color,
          } = status;
          const hasOption = allStatuses.find(i => i.jira_field_id === jira_field_id);

          if (!hasOption) {
            const isExisted = allStatuses.find(item => item.id === id);

            if (!isExisted) {
              allStatuses.push({
                id,
                jira_field_id,
                value: name,
                icon: {
                  name: 'status-2',
                  type: 'bold',
                  size: 20,
                  color,
                },
              });
            }
          }
        });
      }
    });

    if (projects.find(i => !i.is_jira)) {
      allStatuses.unshift(...filterConstants.STATUS_OPTIONS);
    }

    return allStatuses;
  },
  getPriorityOptions(projectIds) {
    const allPriority = [];
    const projects = this.getProjectsOptions(projectIds);

    projects.filter(item => item.is_jira).forEach(project => {
      const jiraPriority = Store.getters['columns/getJiraColumnByNameAndProjectId']('priority', project.id);

      if (jiraPriority && jiraPriority.options.length) {
        jiraPriority.options.forEach(status => {
          const {
            id, jira_field_id, name, value, is_default, icon, color,
          } = status;
          const hasOption = allPriority.find(i => i.jira_field_id === jira_field_id);

          if (!hasOption) {
            const isExisted = allPriority.find(item => item.id === id);

            if (!isExisted) {
              allPriority.push({
                id,
                jira_field_id,
                value: name,
                img: icon,
              });
            }
          }
        });
      }
    });

    if (projects.find(i => !i.is_jira)) {
      allPriority.unshift(...filterConstants.PRIORITY_OPTIONS);
    }

    return allPriority;
  },
  checkExistedValues(filterProp, values, projectIds, customColumnData) {
    let chekedValues = values;

    const resources = [
      filterConstants.PROPERTY.resource_id,
      filterConstants.PROPERTY.assignee,
      filterConstants.PROPERTY.reporter,
    ];

    const projects = [
      filterConstants.PROPERTY.gantt_id,
    ];

    const multiviews = [
      filterConstants.PROPERTY.portfolio_id,
    ];

    if (resources.includes(filterProp) && Array.isArray(values)) {
      let allowedValues = [];

      if (filterProp === filterConstants.PROPERTY.assignee) {
        allowedValues = [unassigned.id];
      }

      chekedValues = values.filter(id => {
        const resourceData = Store.getters['resourcesModel/getResourceById'](id);

        return allowedValues.includes(id)
          || (resourceData && resourceData.resourceProjects?.find(item => projectIds.includes(item.projectId)));
      });

      // if (filterConstants.PROPERTY.assignee === filterProp) {
      //   chekedValues = chekedValues.filter(resourceId => {
      //     const resourceTasks = Store.getters['tasksModel/getTasksByResourceIdAndGanttIds'](resourceId, projectIds);

      //     if (resourceTasks.length) {
      //       return resourceId;
      //     }
      //   });
      // }
    }

    if (projects.includes(filterProp) && Array.isArray(values)) {
      chekedValues = values.filter(id => projectIds.find(projectId => projectId == id));
    }

    if (multiviews.includes(filterProp) && Array.isArray(values)) {
      chekedValues = values.filter(id => {
        const projectData = multiViewsProjectsModel.getProjectDataById(id);

        if (projectData && !projectData?.is_archived) {
          return id;
        }
      });
    }

    if (customColumnData && filterProp !== constants.CUSTOM_COLUMNS_TYPES.checkbox.id) {
      if (Array.isArray(values) && values.length) {
        const customColumnCheckedValues = values.filter(id => {
          const customColumnOption = customColumnData.options.find(option => option.id === id);

          if (filterProp === constants.CUSTOM_COLUMNS_TYPES.resources.id) {
            const resourceData = customColumnOption && Store.getters['resourcesModel/getResourceById'](customColumnOption.resource_id);

            return resourceData && resourceData.resourceProjects?.find(item => projectIds.includes(item.projectId));
          }

          return !!customColumnOption;
        });

        chekedValues = customColumnCheckedValues;
      }
    }

    return chekedValues;
  },
  getEmptyFilter() {
    const currentFilter = Store.getters['filter/currentFilter'];
    const emptyFilter = {};

    Object.keys(currentFilter?.properties).forEach(key => {
      if (key in filterConstants.EMPTY_PROPERTIES) {
        const value = filterConstants.EMPTY_PROPERTIES[key];

        emptyFilter[key] = value;
      }
    });

    return emptyFilter;
  },
  checkEnabledValues(properties) {
    let hasValues = false;

    Object.keys(properties).forEach(key => {
      const value = properties[key];

      if (key === filterConstants.PROPERTY.overdue && value) {
        hasValues = true;
      }

      if (key !== filterConstants.PROPERTY.overdue && value !== '' && value !== null && key !== 'customColumns') {
        hasValues = true;
      }
    });

    Object.keys(properties).forEach(prop => {
      if (prop === 'customColumns') {
        const customColumnsProperties = properties[prop];

        if (customColumnsProperties) {
          Object.values(customColumnsProperties).forEach(value => {
            if (value !== '') {
              hasValues = true;
            }
          });
        }
      }
    });

    return hasValues;
  },
  checkFilterValues(filter, projectIds) {
    if (!filter) {
      return null;
    }

    let changes = { ...filter };
    let hasChanges = false;

    Object.keys(filter).forEach(key => {
      const value = filter[key];
      const checkedValue = this.checkExistedValues(key, value, projectIds);

      if (checkedValue && value.length !== checkedValue.length) {
        hasChanges = true;
        changes = {
          ...changes,
          [key]: checkedValue.length ? checkedValue : '',
        };
      }

      if (key === 'customColumns') {
        const customColumns = filter[key];

        Object.keys(customColumns).forEach(columnId => {
          const columnData = Store.getters['columns/getCustomColumnById'](columnId);

          if (typeof columnData === 'undefined') return;

          if (columnData) {
            const customValue = customColumns[columnId];
            const checkedCustomValue = this.checkExistedValues(columnData.type, customValue, projectIds, columnData);

            if (customValue.length !== checkedCustomValue.length) {
              hasChanges = true;
              changes = {
                ...changes,
                customColumns: {
                  ...changes.customColumns,
                  [columnId]: checkedCustomValue.length ? checkedCustomValue : '',
                },
              };
            }
          }
        });
      }
    });

    if (hasChanges) {
      return {
        ...filter,
        ...changes,
      };
    }

    return null;
  },
  getSavedFilters(savedFilters = {}, currentFilter) {
    const savedFiltersByType = savedFilters[currentFilter.type];
    const currentRoute = routerHelper.getCurrentRoute();
    let filters = [];

    if (currentFilter.type === 'workload' && currentRoute.name === 'workload' && savedFiltersByType) {
      return savedFiltersByType.filter(filter => !filter.project_id && !filter.multiview_id);
    }

    if (savedFiltersByType) {
      if (currentFilter.project_id || currentFilter.multiview_id) {
        filters = savedFiltersByType.filter(filter => currentFilter?.project_id === filter.project_id || currentFilter?.multiview_id === filter.multiview_id);
      } else {
        filters = savedFiltersByType;
      }
    }

    return filters;
  },
  getProjectIdsByRoute(route) {
    const routesWithAllProjects = [
      'progressReports', 
      'budgetReports', 
      'timeReports', 
      'reportsDetail', 
      'workload', 
      'workloadTaskRoute', 
      'listView', 
      'listTaskRoute', 
      'userLogs',
    ];

    let projectIds = [];

    if (route.name === 'project' || route.name === 'taskRoute') {
      projectIds = [+route.params.projectId];
    }

    if (route.name === 'projectsMultiView' || route.name === 'multiviewTaskRoute') {
      const multiviewData = multiViewsProjectsModel.getProjectDataById(route.params.multiviewID);

      projectIds = (multiviewData?.ganttIDs || []).filter(ganttId => rights.project.hasRightSomeOne(ganttId, PORTFOLIO_PROJECT_VIEW_RIGHTS));
    }

    if (routesWithAllProjects.includes(route.name)) {
      projectIds = projectsModel.getAllProjects().filter(p => !p.is_archived).map(o => o.gantt_id);
    }

    return projectIds;
  },
  createCustomColumnItem(columnId) {
    const columnData = Store.getters['columns/getCustomColumnByIdFromMap'](columnId);

    const item = {
      label: columnData.name,
      property: columnData.id,
      columnId: columnData.id,
      typeId: columnData.type,
      placeholder: __('filter_task_type_any'),
      template: this.getTemplateForCustomColumnItem(columnData.type),
    };

    return item;
  },
  getTemplateForCustomColumnItem(typeId) {
    if ([
      constants.CUSTOM_COLUMNS_TYPES.select.id,
      constants.CUSTOM_COLUMNS_TYPES.multiselect.id,
      constants.CUSTOM_COLUMNS_TYPES.tags.id,
      constants.CUSTOM_COLUMNS_TYPES.color.id,
      constants.CUSTOM_COLUMNS_TYPES.resources.id,
      constants.CUSTOM_COLUMNS_TYPES.checkbox.id,
    ].includes(typeId)) {
      return 'dropdown';
    }

    if ([constants.CUSTOM_COLUMNS_TYPES.text.id, constants.CUSTOM_COLUMNS_TYPES.date.id].includes(typeId)) {
      return 'input';
    }

    return null;
  },
  getOptionsForCustomColumnItem(options, typeId) {
    if (typeId === constants.CUSTOM_COLUMNS_TYPES.checkbox.id) {
      return [
        {
          id: '1',
          value: __('filter_checkbox_type_custom_column_off'),
        },
        {
          id: '2',
          value: __('filter_checkbox_type_custom_column_on'),
        },
      ];
    }

    // if (!options && !options.length) return;
    if (!options?.length) return [];

    if (typeId === constants.CUSTOM_COLUMNS_TYPES.resources.id) {
      const resources = customColumnsComponent.filterPeopleOptions(options);

      resources.sort((a, b) => {
        if (!a.userId) return 1;

        return -1;
      });

      return this.preapreResourcesOptions(resources);
    }

    if (typeId === constants.CUSTOM_COLUMNS_TYPES.color.id) {
      return options.map(opt => ({
        id: opt.id,
        color: opt.value,
      }));
    }

    if (typeId === constants.CUSTOM_COLUMNS_TYPES.tags.id) {
      return options.map(opt => ({
        id: opt.id,
        value: opt.value,
        color: opt.color,
      }));
    }

    return options.map(opt => ({
      id: opt.id,
      value: opt.value,
    }));
  },
  getAnalyticFrom(route) {
    if (!route) return;

    if (route.includes('project') || app.config.mode.isExport) {
      if (route.includes('calendar')) return 'calendar';

      return 'project & portfolio';
    }
    if (route.includes('workload')) return 'workload';
    if (route.includes('tasks/list')) return 'my tasks';
    if (route.includes('timelog')) return 'my time log';
    if (route.includes('reports')) return 'reports';
  },
  getAnalyticRoute(route) {
    let from = '';

    if (app.config.mode.isExport) {
      const from = this.currentFilter.type === 'project' ? 'Project' : 'Portfolio';

      return `${from}/Export`;
    }

    if (route.includes('project')) {
      from = route.includes('project/') ? 'Project' : 'Portfolio';

      if (route.includes('gantt')) return `${from}/Gantt`;
      if (route.includes('board')) return `${from}/Board`;
      if (route.includes('workload')) return `${from}/Worcload`;
      if (route.includes('calendar')) return `${from}/calendar`;
    }

    if (route.includes('workload')) return 'Worcload';
    if (route.includes('tasks/list')) return `${from}MyTasks`;
    if (route.includes('timelog')) return `${from}MyTimeLog`;
    if (route.includes('reports')) {
      from = 'Reports';

      if (route.includes('timeloglist')) return `${from}/Timelog`;
      if (route.includes('costslist')) return `${from}/Costs`;
    }
  },
  getAnalyticType(filterType, properties) {
    const types = [];
    const keys = Object.keys(properties);

    const fillOptionCheck = option => (Array.isArray(option) ? option.length : _.isObject(option) ? (option.start || option.period || option.from || option.to) : !!option);

    keys.forEach(key => {
      if (key === 'customColumns') {
        types.push('custom fields');

        return;
      }
      if (!fillOptionCheck(properties[key])) return;

      switch (key) {
      case 'task_name':
      case 'text':
        types.push('task name');
        break;
      case 'gantt_id':
        types.push('projects');
        break;
      case 'resource_id':
      case 'resources':
        if (filterType === 'workload') {
          types.push('assignee');
        } else {
          types.push('resources');
        }
        break;
      case 'assignee':
        types.push(filterType === 'timeloglist' ? 'user' : 'assignee');
        break;
      case 'owner_id':
        types.push('creater');
        break;
      case 'cost_range':
      case 'rangeDate':
        types.push('date range');
        break;
      case 'start_date':
      case 'startDate':
        types.push('start date');
        break;
      case 'end_date':
      case 'endDate':
        types.push('end date');
        break;
      case 'created_at':
      case 'creationDate':
        types.push('creation date');
        break;
      case 'overdue':
        types.push('overdue tasks');
        break;
      case 'time':
        types.push('time (timelog report)');
        break;
      case 'comment':
        types.push('comment (timelog report)');
        break;
      default:
        types.push(key);
      }
    });

    return types;
  },
  getAnalitycsParams(route, filterProps, filterType, isSaved) {
    if (!route) return;

    const path = route?.path;

    if (path.includes('/reports/')) {
      const reportName = reportConstants.FILTER_NAMES[route?.name || ''] + (route?.params?.type.charAt(0).toUpperCase() + route?.params?.type.slice(1));
      const params = {
        report_type: reportName,
        saved_filter_used: isSaved,
      };

      if ('gantt_id' in filterProps) {
        const projectIds = filterProps.gantt_id;

        if (projectIds.length) {
          params.projects_in_filter = projectIds.length;
        }
      }

      if ('rangeDate' in filterProps) {
        const start = filterProps.rangeDate.start;
        const end = filterProps.rangeDate.end;
        const period = filterProps.rangeDate.period;

        if (period && period.length) {
          params.date_range_type = 'preset';
          params.preset_name = filterProps.rangeDate.period;
        } else {
          params.date_range_type = 'custom';
          params.сustom_date_range = {
            start: start?.length ? start : '',
            end: end?.length ? end : '',
          };
        }
      }

      return {
        event: 'report_filter_change',
        params,
      };
    }

    return {
      event: 'filter_applied',
      params: {
        saved: isSaved,
        from: this.getAnalyticFrom(path),
        route: this.getAnalyticRoute(path),
        type: this.getAnalyticType(filterType, filterProps),
      },
    };
  },
  prepareFilterToastNotificationForExport(add) {
    const vueToastRightContainers = document.documentElement.querySelectorAll('.Vue-Toastification__container.top-right');

    if (add) {
      if (app.config.mode.isExport) {
        vueToastRightContainers.forEach(el => {
          el.classList.add('export');
        });
      }
    } else {
      _.debounce(() => {
        vueToastRightContainers.forEach(el => {
          el.classList.remove('export');
        });
      }, 5000);
    }
  },
  getIncompleteTasksFilter(filterProps) {
    const resourceData = Store.getters['resourcesModel/getResourceByUserId'](user.id);

    return {
      ...filterProps,
      status: ['1', '2'],
      assignee: [resourceData.id],
    };
  },
  getThisMonthFilter(filterProps) {
    const format = 'YYYY-MM-DD HH:mm:ss';

    return {
      ...filterProps,
      date: {
        start: moment().startOf('month').format(format),
        end: moment().endOf('month').format(format),
        period: 'this_month',
      },
    };
  },
  checkCustomColumnsAccessByRouteAndRights() {
    const routesWithCustomColumnsFilter = ['listView', 'project', 'projectsMultiView', 'workload'];
    const currentRoute = routerHelper.getCurrentRoute();

    return (Store.getters.isLink || routesWithCustomColumnsFilter.includes(currentRoute.name)) && pricingHelpers.checkPricingAccess('custom_fields');
  },
};

export default helpers;
